// Helper functions for device detection
function isMobile() {
    return window.innerWidth < 768;
}

function isDesktop() {
    return window.innerWidth >= 768;
}

class CustomAccordion extends HTMLElement {
    constructor() {
        super();
        this.detailsEl = null;
        this.summaryEl = null;
        this.contentEl = null;
        this.isOpen = false;
        this.durationMs = 250;
        this.easing = 'ease';
        this.handleClick = null;
        this.isCloseSiblings = this.dataset.closeSiblings === 'true' ? true : false;
        this.collapseOnDesktop = true;
        if (this.dataset.collapseOnDesktop) {
            this.collapseOnDesktop = this.dataset.collapseOnDesktop === 'true' ? true : false;
        }
        this.collapseOnMobile = true;
        if (this.dataset.collapseOnMobile) {
            this.collapseOnMobile = this.dataset.collapseOnMobile === 'true' ? true : false;
        }
        this.expandByDefault = false;
        if (this.dataset.expandByDefault) {
            this.expandByDefault = this.dataset.expandByDefault === 'true' ? true : false;
        }
    }

    connectedCallback() {
        this.detailsEl = this.querySelector('details');
        if (!this.detailsEl) return;

        this.summaryEl = this.detailsEl.querySelector('summary');
        this.contentEl = this.summaryEl.nextElementSibling;
        if (!this.summaryEl || !this.contentEl) return;

        this.isOpen = this.detailsEl.open;

        // If already open, add active class
        if (this.isOpen) {
            this.detailsEl.classList.add('active');
            this.contentEl.style.maxHeight = 'none';
            this.contentEl.style.opacity = '1';
            this.contentEl.style.overflow = 'visible';
        }

        this.bindEvents();

        if (isMobile() && this.expandByDefault) {
            this.toggle();
        }
    }

    bindEvents() {
        this.handleClick = (e) => {
            e.preventDefault();
            if (isDesktop() && !this.collapseOnDesktop) return;
            if (isMobile() && !this.collapseOnMobile) return;

            this.toggle();
        };
        this.summaryEl.addEventListener('click', this.handleClick);
    }

    closeSiblings() {
        const siblings = Array.from(this.parentElement?.querySelectorAll('accordion-component') || [])
            .filter((el) => el !== this);
        siblings.forEach((sib) => {
            if (typeof sib.collapse === 'function') {
                sib.collapse();
            }
        });
    }

    toggle() {
        this.isOpen = !this.isOpen;
        if (!this.detailsEl.classList.contains('active')) {
            if (this.isCloseSiblings) {
                this.closeSiblings.bind(this)();
            }
            this.detailsEl.open = true;
            this.expand();
        } else {
            this.collapse();
        }

        // bubble a toggle event for external controllers if needed
        this.dispatchEvent(new CustomEvent('toggle', { bubbles: true, detail: { current: this.detailsEl, open: this.isOpen } }));
        this.detailsEl.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');
    }

    expand(duration = this.durationMs) {
        // BƯỚC 1: Tắt transition tạm thời để tránh xung đột khi đo chiều cao
        this.contentEl.style.transition = 'none';

        // BƯỚC 2: Đo chiều cao thực tế
        this.contentEl.style.maxHeight = 'none';
        const targetHeight = this.contentEl.scrollHeight;

        // BƯỚC 3: Set lại về 0 ngay lập tức (vẫn đang tắt transition)
        this.contentEl.style.maxHeight = '0px';
        this.contentEl.style.opacity = '0';
        this.detailsEl.classList.add('active');

        // BƯỚC 4: FORCE REFLOW (Quan trọng nhất)
        // Dòng này ép trình duyệt nhận diện trạng thái 0px NGAY LẬP TỨC
        // trước khi chúng ta bật lại transition.
        void this.contentEl.offsetWidth;

        // BƯỚC 5: Bật lại transition và bắt đầu chạy animation
        this.contentEl.style.transition = `max-height ${duration}ms ease, opacity ${duration}ms ease`;

        // Chạy animation ngay (không cần chờ requestAnimationFrame lồng nhau nữa)
        requestAnimationFrame(() => {
            this.contentEl.style.maxHeight = `${targetHeight}px`;
            this.contentEl.style.opacity = '1';
        });

        // BƯỚC 6: Dọn dẹp sau khi chạy xong
        setTimeout(() => {
            // Chỉ reset về none nếu animation không bị ngắt quãng (vẫn đang mở)
            if (this.detailsEl.open) {
                this.contentEl.style.maxHeight = 'none';
                this.contentEl.style.overflow = 'visible';
                // Xóa inline transition để trả về cho CSS quản lý (nếu có)
                this.contentEl.style.transition = '';
            }
        }, duration);
    }

    collapse(duration = this.durationMs) {
        // SET overflow hidden IMMEDIATELY to prevent inner content from showing
        this.contentEl.style.overflow = 'hidden';

        // Recalculate height to account for any padding/layout changes
        const currentHeight = this.contentEl.scrollHeight;
        this.contentEl.style.maxHeight = `${currentHeight}px`;
        this.detailsEl.classList.remove('active');

        // Use CSS transition for animation
        this.contentEl.style.transition = `max-height ${duration}ms ease, opacity ${duration}ms ease`;

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.contentEl.style.maxHeight = '0px';
                this.contentEl.style.opacity = '0';
            });
        });

        // Close details after animation
        setTimeout(() => {
            this.detailsEl.open = false;
        }, duration);
    }
}

if (!customElements.get('accordion-component')) {
    customElements.define('accordion-component', CustomAccordion);
}

class PriceRange extends HTMLElement {
	constructor() {
		super();

		this.minRangeInput = this.querySelector('.price-range__input--min');
		this.maxRangeInput = this.querySelector('.price-range__input--max');

		const numberInputs = this.querySelectorAll('.price-range__number');
		this.minPriceInput = numberInputs[0];
		this.maxPriceInput = numberInputs[1];

		if (!this.minRangeInput || !this.maxRangeInput || !this.minPriceInput || !this.maxPriceInput) return;

		this.minPriceInput.addEventListener('focus', function () { this.select(); });
		this.maxPriceInput.addEventListener('focus', function () { this.select(); });
		this.minPriceInput.addEventListener(
			'change',
			this.handleInputMinChange.bind(this),
		);
		this.maxPriceInput.addEventListener(
			'change',
			this.handleInputMaxChange.bind(this),
		);

		this.minRangeInput.addEventListener(
			'change',
			this.handleRangeMinChange.bind(this),
		);
		this.maxRangeInput.addEventListener(
			'change',
			this.handleRangeMaxChange.bind(this),
		);
		this.minRangeInput.addEventListener(
			'input',
			this.handleRangeMinInput.bind(this),
		);
		this.maxRangeInput.addEventListener(
			'input',
			this.handleRangeMaxInput.bind(this),
		);
	}


	handleInputMinChange(event) {
		event.preventDefault();
		var val = parseInt(event.target.value) || 0;
		var maxBound = parseInt(this.maxPriceInput.value) || parseInt(this.maxRangeInput.value) || parseInt(event.target.getAttribute('max')) || 0;
		var minBound = parseInt(event.target.getAttribute('min')) || 0;
		var clampedVal = Math.max(Math.min(val, maxBound), minBound);
		event.target.value = clampedVal;
		this.minRangeInput.value = clampedVal;
		var maxLimit = parseInt(this.minRangeInput.max) || 1;
		this.minRangeInput.parentElement.style.setProperty(
			'--range-min',
			`${(clampedVal / maxLimit) * 100}%`,
		);
	}

	handleInputMaxChange(event) {
		event.preventDefault();
		var val = parseInt(event.target.value) || 0;
		var minBound = parseInt(this.minPriceInput.value) || parseInt(this.minRangeInput.value) || parseInt(event.target.getAttribute('min')) || 0;
		var maxBound = parseInt(event.target.getAttribute('max')) || parseInt(this.maxRangeInput.max) || 0;
		var clampedVal = Math.min(Math.max(val, minBound), maxBound);
		event.target.value = clampedVal;
		this.maxRangeInput.value = clampedVal;
		var maxLimit = parseInt(this.maxRangeInput.max) || 1;
		this.maxRangeInput.parentElement.style.setProperty(
			'--range-max',
			`${(clampedVal / maxLimit) * 100}%`,
		);
	}

	handleRangeMinChange(event) {
		event.stopPropagation();
		this.minPriceInput.value = event.target.value;
		this.minPriceInput.dispatchEvent(
			new Event('change', { bubbles: true }),
		);
	}

	handleRangeMaxChange(event) {
		event.stopPropagation();
		this.maxPriceInput.value = event.target.value;
		this.maxPriceInput.dispatchEvent(
			new Event('change', { bubbles: true }),
		);
	}

	handleRangeMinInput(event) {
		var maxBound = parseInt(this.maxRangeInput.value) || parseInt(event.target.max) || 0;
		event.target.value = Math.min(
			parseInt(event.target.value) || 0,
			maxBound
		);
		var maxLimit = parseInt(event.target.max) || 1;
		event.target.parentElement.style.setProperty(
			'--range-min',
			`${(parseInt(event.target.value) / maxLimit) * 100}%`,
		);
		this.minPriceInput.value = event.target.value;
	}

	handleRangeMaxInput(event) {
		var minBound = parseInt(this.minRangeInput.value) || parseInt(event.target.min) || 0;
		event.target.value = Math.max(
			parseInt(event.target.value) || 0,
			minBound
		);
		var maxLimit = parseInt(event.target.max) || 1;
		event.target.parentElement.style.setProperty(
			'--range-max',
			`${(parseInt(event.target.value) / maxLimit) * 100}%`,
		);
		this.maxPriceInput.value = event.target.value;
	}
}

if (!customElements.get('price-range')) {
	customElements.define('price-range', PriceRange);
}